import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import 'react-toastify/dist/ReactToastify.css';

import './css/index.css';
import './css/tailwind.output.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import history from './history';
import store, { persistor } from './store';
import { ErrorBoundary } from './components/error/ErrorBoundary';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ErrorBoundary catchErrors="always">
          <ConnectedRouter history={history}>
            <ToastContainer />
            <App />
          </ConnectedRouter>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
